import React from "react";
import noVideosmIcon from "@assets/images/noVideosmIcon.webp";
import nomusicIconSM from "@assets/images/musicIconSM.webp";
import VideoBorder from "@assets/images/borders/video-border.webp";
import routes from "@src/routes/routes";
import { getImageUrlWithExpiry } from "@src/utils/ImageExpirtyHelper";
import type { INotificationItemComp } from "@src/types/AppTypes";

const NotificationItem: React.FC<INotificationItemComp> = React.memo(
  ({ item, markAsRead, index, navigate, setShowNotifications }) => {
    return (
      <>
        <li
          onClick={async (e) => {
            e.preventDefault();
            if (!item.is_read) {
              await markAsRead(item.id, index);
            }
            const navigatePath =
              item.type === "Episode"
                ? routes.allEpisodes + `?season=${item.number_of_season}`
                : item.type === "Music"
                ? routes.allMusic
                : "/products/" + item.item_slug;
            setShowNotifications(false);
            navigate(navigatePath);
          }}
          className={`${
            item.is_read ? "opacity-60 hover:cursor-auto" : "hover:opacity-80"
          }`}
        >
          <h4 className="text-xl mb-3 text-primary">{item.message}</h4>
          <div className="flex items-start justify-start gap-3 w-full cursor-pointer">
            <div className="p-1 flex-shrink-0 grid w-32 h-20 max-sm:w-28 max-sm:h-16 place-items-center relative max-w-lg max-lg:mx-0 overflow-hidden">
              <div className="absolute size-full mx-auto my-auto skeleton px-3 hidden"></div>
              <div className="absolute top-0 left-0 size-full -z-[2]">
                <img
                  className="absolute size-full object-contain z-[1]"
                  src={getImageUrlWithExpiry(item.thumbnail)}
                  alt="episode img"
                />
                <img
                  className="bg-gradient-to-t from-[#184AF4] to-[#1D1159] size-full object-cover blur-sm"
                  src={getImageUrlWithExpiry(item.thumbnail)}
                  alt="episode img"
                />
              </div>
              <img
                className="absolute size-full top-0 left-0 z-[-1]"
                src={VideoBorder}
                alt=""
              />
            </div>
            <div className="flex flex-col justify-between max-sm:items-start w-[calc(100%-140px)] max-sm:w-[calc(100%-115px)] gap-1">
              <div className="flex items-center gap-3">
                {item.type === "Music" ? (
                  <img src={nomusicIconSM} alt="" className="w-6" />
                ) : item.type === "Episode" ? (
                  <img src={noVideosmIcon} alt="" className="w-6" />
                ) : (
                  ""
                )}

                <span className="text-lg text-primary">{item.type}</span>
              </div>
              <p className="text-primary text-base w-full truncate">
                {item.title}
              </p>
              <span className="text-primary text-sm">
                {new Date(item.date).toLocaleDateString() ===
                new Date().toLocaleDateString()
                  ? new Date(item.date).toLocaleString([], {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })
                  : new Date(item.date).toLocaleString([], {
                      dateStyle: "short",
                    }) +
                    " " +
                    new Date(item.date).toLocaleString([], {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
              </span>
            </div>
          </div>
        </li>
        <div className="w-full h-4 bg-contain bg-no-repeat bg-[url('@assets/images/cartsummaryBorder.webp')] last:hidden"></div>
      </>
    );
  }
);

export default NotificationItem;
